<template>
  <div v-if="location" class="flex-center cursor-pointer" data-toggle="modal" data-target="#editLocationModal" @click="populateForm()">
    <i class="fas fa-cog text-primary fa-lg" title="Edit Location"></i>
  </div>

  <EditLocation 
    v-if="edit" 
    :edit="true" 
    :form="form"
    :states="states"
    :updates="true"
    @updateLocation="saveLocation"> 
  </EditLocation>
</template>

<script>
  import EditLocation from '@/Components/Modals/AddNewLocation'

  export default {
    components: {
      EditLocation
    },
    data() {
      return {
        edit: false,
        form: this.$inertia.form({
          company_name: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          postcode: null,
          location_visit_on_day: 'unassigned'
        }),
      }
    },
    props: {
      location: Object,
      states: Array
    },
    methods: {
      populateForm() {
        this.edit = true;
        this.$nextTick(() => {
          this.form.company_name = this.location.company_name
          this.form.address1 = this.location.address1
          document.getElementById('editaddress1').value = this.location.address1
          this.form.address2 = this.location.address2
          this.form.city = this.location.city
          this.form.state = this.location.state
          this.form.phone = this.location.phone
          this.form.phone_mobile = this.location.phone_mobile
          this.form.location_visit_on_day = this.location.location_visit_on_day
        })
      },
      saveLocation() {
        this.form.put(route('mtd.locations.update', this.location.id), {
          preserveState: true,
          onSuccess: () => {
            $('#editLocationModal').modal('hide')
          }
        })
      }
    }
  }
</script>
